const states = [
	{ id: 1, abbreviation: 'AK', name: 'Alaska' },
	{ id: 2, abbreviation: 'AL', name: 'Alabama' },
	{ id: 3, abbreviation: 'AR', name: 'Arkansas' },
	{ id: 4, abbreviation: 'AZ', name: 'Arizona' },
	{ id: 5, abbreviation: 'CA', name: 'California' },
	{ id: 6, abbreviation: 'CO', name: 'Colorado' },
	{ id: 7, abbreviation: 'CT', name: 'Connecticut' },
	{ id: 8, abbreviation: 'DC', name: 'District of Columbia' },
	{ id: 9, abbreviation: 'DE', name: 'Delaware' },
	{ id: 10, abbreviation: 'FL', name: 'Florida' },
	{ id: 11, abbreviation: 'GA', name: 'Georgia' },
	{ id: 12, abbreviation: 'HI', name: 'Hawaii' },
	{ id: 13, abbreviation: 'IA', name: 'Iowa' },
	{ id: 14, abbreviation: 'ID', name: 'Idaho' },
	{ id: 15, abbreviation: 'IL', name: 'Illinois' },
	{ id: 16, abbreviation: 'IN', name: 'Indiana' },
	{ id: 17, abbreviation: 'KS', name: 'Kansas' },
	{ id: 18, abbreviation: 'KY', name: 'Kentucky' },
	{ id: 19, abbreviation: 'LA', name: 'Louisiana' },
	{ id: 20, abbreviation: 'MA', name: 'Massachusetts' },
	{ id: 21, abbreviation: 'MD', name: 'Maryland' },
	{ id: 22, abbreviation: 'ME', name: 'Maine' },
	{ id: 23, abbreviation: 'MI', name: 'Michigan' },
	{ id: 24, abbreviation: 'MN', name: 'Minnesota' },
	{ id: 25, abbreviation: 'MO', name: 'Missouri' },
	{ id: 26, abbreviation: 'MS', name: 'Mississippi' },
	{ id: 27, abbreviation: 'MT', name: 'Montana' },
	{ id: 28, abbreviation: 'NC', name: 'North Carolina' },
	{ id: 29, abbreviation: 'ND', name: 'North Dakota' },
	{ id: 30, abbreviation: 'NE', name: 'Nebraska' },
	{ id: 31, abbreviation: 'NH', name: 'New Hampshire' },
	{ id: 32, abbreviation: 'NJ', name: 'New Jersey' },
	{ id: 33, abbreviation: 'NM', name: 'New Mexico' },
	{ id: 34, abbreviation: 'NV', name: 'Nevada' },
	{ id: 35, abbreviation: 'NY', name: 'New York' },
	{ id: 36, abbreviation: 'OH', name: 'Ohio' },
	{ id: 37, abbreviation: 'OK', name: 'Oklahoma' },
	{ id: 38, abbreviation: 'OR', name: 'Oregon' },
	{ id: 39, abbreviation: 'PA', name: 'Pennsylvania' },
	{ id: 40, abbreviation: 'RI', name: 'Rhode Island' },
	{ id: 41, abbreviation: 'SC', name: 'South Carolina' },
	{ id: 42, abbreviation: 'SD', name: 'South Dakota' },
	{ id: 43, abbreviation: 'TN', name: 'Tennessee' },
	{ id: 44, abbreviation: 'TX', name: 'Texas' },
	{ id: 45, abbreviation: 'UT', name: 'Utah' },
	{ id: 46, abbreviation: 'VA', name: 'Virginia' },
	{ id: 47, abbreviation: 'VT', name: 'Vermont' },
	{ id: 48, abbreviation: 'WA', name: 'Washington' },
	{ id: 49, abbreviation: 'WI', name: 'Wisconsin' },
	{ id: 50, abbreviation: 'WV', name: 'West Virginia' },
	{ id: 51, abbreviation: 'WY', name: 'Wyoming' },
];
export default states;

const statesByAbbreviation = {};
states.forEach((state) => statesByAbbreviation[state.abbreviation] = state.id);

export { states, statesByAbbreviation };